import { BlockWrapper } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import clsx from 'clsx';
import { useState, useCallback } from 'react';
import { HomeTileQuiz, Loading, isFloat } from '../components';
import Filter from './Filter';
import style from './block.module.scss';

function Block({ data, tags, total, isUserConnected, isEmailVerified }) {
    const [filter, setFilter] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [posts, setPosts] = useState(data);
    const [totalPosts, setTotalPosts] = useState(total);
    const [expired, setExpired] = useState(false);

    const loadMore = useCallback(
        (nextPage, filter, expired, append) => {
            if (isLoading || isFloat(nextPage)) return;
            let params = {
                page: Math.floor(nextPage),
                per_page: 12,
                expired: expired,
                quiz_tags: filter.length > 0 ? filter.join() : -1,
                acf_format: 'standard',
            };
            setIsLoading(true);
            apiFetch({
                path: '/quiz/v1/load?' + new URLSearchParams(params).toString(),
                parse: false,
            }).then((res) => {
                res.json().then((data) => {
                    if (append) setPosts([...posts, ...data.array]);
                    else setPosts(data.array);
                    setTotalPosts(data.total);
                });
                setIsLoading(false);
            });
        },
        [isLoading, posts],
    );

    const handleFilter = ({ active, id }) => {
        var temp;
        if (!active) setFilter((temp = filter.filter((termId) => termId !== id)));
        else setFilter((temp = filter.concat(id)));
        loadMore(1, temp, expired, false);
    };

    const handleStatus = () => {
        setExpired(!expired);
        loadMore(1, filter, !expired, false);
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <h1 className={style.title}>Jeux concours</h1>

            <div className={style.status}>
                <span className={clsx(style.options, !expired && style.selected)} onClick={handleStatus}>
                    En cours
                </span>
                <span className={clsx(style.options, expired && style.selected)} onClick={handleStatus}>
                    Passés
                </span>
            </div>

            <div className={style.tagsContainer}>
                {tags &&
                    tags.length > 0 &&
                    tags.map((el) => <Filter key={el.name} onClick={handleFilter} name={el.name} id={el.term_id} />)}
            </div>

            <div className={style.tileContainer}>
                {posts &&
                    posts.length > 0 &&
                    posts.map((el) => <HomeTileQuiz key={el.link} post={el} isEmailVerified={isEmailVerified} />)}
            </div>

            {totalPosts > posts.length && (
                <Loading
                    isLoading={isLoading}
                    onViewPortAppear={() => loadMore(posts.length / 12 + 1, filter, expired, true)}
                />
            )}
        </BlockWrapper.Div>
    );
}

export default Block;
